<script setup lang="ts">
import type { LabelProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { Label } from 'reka-ui';
import { cn } from '@/utils/shadcn/lib/utils';
import { labelVariants } from './variants';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = withDefaults(defineProps<Props>(), {
    class: '',
    for: undefined,
    inline: false,
});

interface Props extends LabelProps {
    class?: HTMLAttributes['class']
    for?: string
    inline?: boolean
}

const delegatedProps = reactiveOmit(props, 'class', 'inline');
</script>

<template>
    <Label
        data-slot="label"
        v-bind="delegatedProps"
        :class="
            cn(
                labelVariants({
                    inline: props.inline,
                }),
                props.class,
            )
        "
    >
        <slot></slot>
    </Label>
</template>
